import Permissions from "../../models/Permissions";

const NCM = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "NCM",
  icon: "fa fa-wrench",
  group: "NCM",
  permissions,
};

export default [
  {
    path: "/Ncm",
    name: "NCM",
    component: NCM,
    meta,
  },
];
